'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { getSenderId, getSenderType } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getFromSenderName, getOriginalFromSenderEmail } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { isThreadComment } from 'conversations-message-history/comment-message/operators/cmComparators';
import { getMessage } from 'conversations-message-history/unpublished-messages/operators/getters';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import Small from 'UIComponents/elements/Small';
import SenderAvatar from '../avatar/SenderAvatar';
import CommentMessageBody from '../comment/CommentMessageBody';
import { LAST } from 'conversations-message-history/constants/messagePositionDescriptors';
import { AGENT } from 'conversations-message-history/constants/messageUses';
import { COMMENT } from 'conversations-message-history/constants/tileMessageUses';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageAvatar from '../primary-message/components/PrimaryMessageAvatar';
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import PrimaryMessageFooter from '../primary-message/components/PrimaryMessageFooter';
import PrimaryMessageHeaderContent from '../primary-message/components/PrimaryMessageHeaderContent';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { senderEmailDoesNotMatchVisitor } from 'conversations-message-history/senders/operators/senderEmailDoesNotMatchVisitor';
import Sender from 'conversations-message-history/senders/records/Sender';
import TileMessage from '../tile-message/TileMessage';
import FlexRow from '../shared/components/FlexRow';
import CommonMessageContent from '../common-message/CommonMessageContent';
import CommonAttachmentsFooter from './CommonAttachmentsFooter';
import CommonMessageSection from './CommonMessageSection';
import CommonMessageHeaderContent from '../common-message-header/CommonMessageHeaderContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ActivelyPublishingMessage extends PureComponent {
  constructor(...args) {
    super(...args);
    this.renderPrimaryMessageContent = () => {
      const {
        message: activelyPublishingMessage,
        plainTextMode
      } = this.props;
      const message = getMessage(activelyPublishingMessage);
      return /*#__PURE__*/_jsx(CommonMessageContent, {
        message: message,
        plainTextMode: plainTextMode
      });
    };
  }
  renderPrimaryMessageAvatar() {
    const {
      message: activelyPublishingMessage,
      onClickAvatar,
      senders
    } = this.props;
    const message = getMessage(activelyPublishingMessage);
    const senderId = getSenderId(message);
    const senderType = getSenderType(message);
    const asyncSender = findSender(senderId, senderType, senders);
    let sender = getData(asyncSender);
    if (!sender || senderEmailDoesNotMatchVisitor({
      sender,
      message
    })) {
      sender = Sender({
        senderType,
        firstName: getFromSenderName(message),
        email: getOriginalFromSenderEmail(message) || null
      });
    }
    const isLoading = isSenderLoading(asyncSender);
    return /*#__PURE__*/_jsx(PrimaryMessageAvatar, {
      children: /*#__PURE__*/_jsx(SenderAvatar, {
        isLoading: isLoading,
        onClick: onClickAvatar,
        sender: sender,
        use: AGENT
      })
    });
  }
  renderHeaderContent() {
    const {
      message: activelyPublishingMessage,
      senders
    } = this.props;
    const message = getMessage(activelyPublishingMessage);
    const senderId = getSenderId(message);
    const senderType = getSenderType(message);
    const asyncSender = findSender(senderId, senderType, senders);
    const isLoading = isSenderLoading(asyncSender);
    let sender = getData(asyncSender);
    if (!sender || senderEmailDoesNotMatchVisitor({
      sender,
      message
    })) {
      sender = Sender({
        senderType,
        firstName: getFromSenderName(message),
        email: getOriginalFromSenderEmail(message) || null
      });
    }
    return /*#__PURE__*/_jsx(PrimaryMessageHeaderContent, {
      children: /*#__PURE__*/_jsx(CommonMessageHeaderContent, {
        isSenderLoading: isLoading,
        sender: sender,
        message: message
      })
    });
  }
  renderHeaderPublishingData() {
    return /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-inbox-message-history.status.publishing.UNPUBLISHED"
      })
    });
  }
  renderFooterSmall() {
    const {
      positionDescriptors
    } = this.props;
    if (!positionDescriptors.includes(LAST)) {
      return null;
    }
    return /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "conversations-inbox-message-history.status.publishing.UNPUBLISHED"
      })
    });
  }
  render() {
    const {
      fileAttachments,
      message: activelyPublishingMessage,
      onClickAvatar,
      positionDescriptors,
      senders
    } = this.props;
    const message = getMessage(activelyPublishingMessage);
    const shouldRenderFooter = positionDescriptors.includes(LAST);
    if (isThreadComment(message)) {
      return /*#__PURE__*/_jsx(TileMessage, {
        className: "selenium-test-marker-comment-message",
        use: COMMENT,
        positionDescriptors: positionDescriptors,
        children: /*#__PURE__*/_jsx(CommentMessageBody, {
          message: message,
          onClickAvatar: onClickAvatar,
          senders: senders,
          renderHeaderMetadata: this.renderHeaderPublishingData
        })
      });
    }
    if (isCommonMessageFormat(message)) {
      return /*#__PURE__*/_jsxs(PrimaryMessage, {
        positionDescriptors: positionDescriptors,
        use: AGENT,
        children: [/*#__PURE__*/_jsxs(FlexRow, {
          children: [this.renderPrimaryMessageAvatar(), /*#__PURE__*/_jsxs(PrimaryMessageContent, {
            children: [this.renderHeaderContent(), /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
              canExpand: true,
              isLastMessage: true,
              children: /*#__PURE__*/_jsx(CommonMessageSection, {
                message: message,
                fileAttachments: fileAttachments,
                renderMessageContent: this.renderPrimaryMessageContent
              })
            }), /*#__PURE__*/_jsx(PrimaryMessageContentSection, {
              children: /*#__PURE__*/_jsx(CommonAttachmentsFooter, {
                message: message,
                fileAttachments: fileAttachments
              })
            })]
          })]
        }), shouldRenderFooter ? /*#__PURE__*/_jsx(PrimaryMessageFooter, {
          children: this.renderFooterSmall()
        }) : null]
      });
    }
    return null;
  }
}
ActivelyPublishingMessage.displayName = 'ActivelyPublishingMessage';
ActivelyPublishingMessage.propTypes = {
  fileAttachments: PropTypes.instanceOf(List),
  message: RecordPropType('ActivelyPublishing').isRequired,
  onClickAvatar: PropTypes.func,
  plainTextMode: PropTypes.bool.isRequired,
  positionDescriptors: PositionDescriptors.isRequired,
  senders: SenderMap
};
ActivelyPublishingMessage.defaultProps = {
  plainTextMode: false
};
export default ActivelyPublishingMessage;